module.exports = __webpack_public_path__ + "static/media/HEART-12-QUEEN.3a7ae884.svg";